module.exports = __webpack_public_path__ + "img/img_pop_bell.6867e11f.png";